import { IconButton } from '@material-ui/core'
import styled, { css } from 'styled-components'

export const IconButtonVerde = styled(IconButton)`
  ${({ theme }) => css`
    color: ${theme.colors.secondary} !important;
  `}
  vertical-align: top !important;
  margin-left: 4px !important;
`
